/**
 * A date or date-time off the API as a timestamp for a chart axis, read in **local** time.
 *
 * Never `new Date(value)` for these: a bare `YYYY-MM-DD` is read as UTC midnight, which is
 * the day before anywhere west of Greenwich, and `YYYY-MM-DD HH:mm:ss` with a space is not
 * ISO at all — Chrome reads it, Safari returns `NaN`.
 */
export function chartTime(value: unknown): number {
  const text = String(value)

  if (/^\d{4}-\d{2}-\d{2}$/.test(text))
    return new Date(`${text}T00:00`).getTime()

  return new Date(text.replace(' ', 'T')).getTime()
}
